import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Button } from '@praktio/common-ui';

import { LogoutTypes } from '../../../../utils/constants';
import { logout } from '../../../../ducks/auth';

import './InactivityModal.scss';

interface IProps {
  show: boolean;
  onHide: () => void;
}

const FiftyNineSecs = 1000 * 59;
const Minute = 1000 * 60;

const InactivityModal = ({ show, onHide }: IProps) => {
  const dispatch = useDispatch();
  const timerId = useRef<NodeJS.Timeout | undefined>();
  const [countdown, setCountdown] = useState(FiftyNineSecs);
  const prevShow = useRef(show);

  useEffect(() => {
    if (show) {
      if (!prevShow.current) {
        setCountdown(FiftyNineSecs);
      }

      const countdownDate = new Date().getTime() + Minute;
      timerId.current = setInterval(() => {
        const difference = countdownDate - new Date().getTime();
        if (difference < 0) {
          clearInterval(timerId.current);
          dispatch(logout(LogoutTypes.Inactivity));
        } else {
          setCountdown(difference);
        }
      }, 1000);
    } else if (timerId.current) {
      clearInterval(timerId.current);
    }

    prevShow.current = show;
  }, [show, dispatch]);

  const seconds = Math.floor((countdown % Minute) / 1000);
  return (
    <Modal
      show={show}
      onHide={onHide}
      onSave={onHide}
      title={
        (
          <div className="header-text">
            <span className="material-icons">warning</span> Your session is about to time out.
          </div>
        ) as any
      }
      saveText="STAY LOGGED IN"
      className="InactivityModal"
      footerAdditions={
        <Button className="secondary" onClick={() => dispatch(logout(LogoutTypes.Normal))}>
          LOG OUT
        </Button>
      }
      notDraggable
    >
      <div className="prompt">
        Are you still here? If not, for security purposes, we'll log you out automatically in{' '}
        <span className="timer">
          {seconds} second{seconds !== 1 ? 's' : ''}
        </span>
        .
      </div>
    </Modal>
  );
};

export default InactivityModal;
